import styled from 'styled-components';

import { ProductType } from '@xing-com/crate-common-graphql-types';
import type { RefinedPremiumContacts } from '@xing-com/crate-upsell-types';
import {
  SingleSizeIllustrationPremiumHeroUpsellDiamond,
  SingleSizeIllustrationProJobsHeroRidingBike,
} from '@xing-com/illustrations';
import { mediaWide } from '@xing-com/layout-tokens';
import { space4XL } from '@xing-com/tokens';
import { Column } from '@xing-com/xing-grid';

import { Salutation } from './salutation';

interface SingleColumnIllustrationAndSalutationProps {
  heading: string;
  premiumContacts?: RefinedPremiumContacts;
  showFacepile: boolean;
  product: ProductType;
}

export const SingleColumnIllustrationAndSalutation: React.FC<
  SingleColumnIllustrationAndSalutationProps
> = ({ heading, premiumContacts, showFacepile, product }) => {
  return (
    <Column size={0} sizeWide={6}>
      <ContentWrapper>
        <Salutation
          heading={heading}
          premiumContacts={premiumContacts}
          showFacepile={showFacepile}
        />
        {product === ProductType.Premium ? (
          <SingleSizeIllustrationPremiumHeroUpsellDiamond />
        ) : (
          <SingleSizeIllustrationProJobsHeroRidingBike />
        )}
      </ContentWrapper>
    </Column>
  );
};

const ContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media ${mediaWide} {
    > svg {
      margin-top: ${space4XL};
      max-width: 80%;
    }
  }
`;
